<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-服务项目-添加
    -->
    <el-dialog
    title="添加服务记录"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true" 
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="服务标题" prop="remark"><el-input v-model="form.remark" placeholder="请输入服务标题" class="max-w460"></el-input></el-form-item>
      <el-form-item label="服务单照片：" prop="form.images">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.images">
          <transition-group>
            <div v-for="(item, index) in form.images" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


    <el-form-item label="术前图片：" prop="form.pre_images">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.pre_images">
          <transition-group>
            <div v-for="(item, index) in form.pre_images" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deletePreImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUploadPre">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

    <el-form-item label="术后图片：" prop="form.after_images">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.after_images">
          <transition-group>
            <div v-for="(item, index) in form.after_images" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteAfterImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUploadAfter">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>
     
      <!-- <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item> -->

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
  <Upload v-if="isupload" :isupload="isupload" type="image" @returnImgs="returnImgsFunc">上传封面图片
    </Upload>

    <Upload v-if="isuploadPre" :isupload="isuploadPre" type="image" @returnImgs="returnImgsFuncPre">上传封面图片
    </Upload>

    <Upload v-if="isuploadAfter" :isupload="isuploadAfter" type="image" @returnImgs="returnImgsFuncAfter">上传封面图片
    </Upload>
</el-dialog>
  
</template>

<script>
import UserApi from '@/api/user.js';
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        remark: '',
        images:[],
        pre_images:[],
        after_images:[],
        sort:50
      },
      loading: false,
      /*验证规则*/
      rules: {
  
      },
      dialogVisible:false,
      isupload:false,
      isuploadPre:false,
      isuploadAfter:false,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add",'user_id'],
  methods: {
    /*打开上传图片*/
    openProductUpload: function () {
      this.isupload = true;
    },
    

    /*上传商品图片*/
    returnImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.images.concat(e);
        this.$set(this.form, "images", imgs);
      }
      this.isupload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.form.images.splice(index, 1);
    },



       /*打开上传图片*/
       openProductUploadPre: function () {
      this.isuploadPre = true;
    },
    

    /*上传商品图片*/
    returnImgsFuncPre(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.pre_images.concat(e);
        this.$set(this.form, "pre_images", imgs);
      }
      this.isuploadPre = false;
    },

    /*删除商品图片*/
    deletePreImg(index) {
      this.form.pre_images.splice(index, 1);
    },


        /*打开上传图片*/
        openProductUploadAfter: function () {
      this.isuploadAfter = true;
    },
    

    /*上传商品图片*/
    returnImgsFuncAfter(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.after_images.concat(e);
        this.$set(this.form, "after_images", imgs);
      }
      this.isuploadAfter = false;
    },

    /*删除商品图片*/
    deleteAfterImg(index) {
      this.form.after_images.splice(index, 1);
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          if(Array.isArray(form.images) == true){
            form.images = JSON.stringify(form.images)
          }
          if(Array.isArray(form.pre_images) == true){
            form.pre_images = JSON.stringify(form.pre_images)
          }
          if(Array.isArray(form.after_images) == true){
            form.after_images = JSON.stringify(form.after_images)
          }
         form.user_id = self.user_id;
         UserApi.add_service(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.video {
  width: 200px;
  height: 110px;
  margin-right: 10px;
}

.video video {
  margin-top: 10px;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/user/user/service/part/add.vue